import { render, staticRenderFns } from "./LogRateStats.vue?vue&type=template&id=1fba00d4&scoped=true"
import script from "./LogRateStats.vue?vue&type=script&lang=js"
export * from "./LogRateStats.vue?vue&type=script&lang=js"
import style0 from "./LogRateStats.vue?vue&type=style&index=0&id=1fba00d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba00d4",
  null
  
)

export default component.exports